// import React, { useState, useEffect } from "react";
// import { FaServer, FaTools, FaCheckCircle, FaDesktop } from "react-icons/fa";
// import API from "../Context/api";

// function DashboardHome() {
//   const [stats, setStats] = useState({
//     totalComputers: 0,
//     needsRepair: 0,
//     inRepair: 0,
//     repaired: 0,
//     operational: 0,
//   });

//   const [makeStats, setMakeStats] = useState([]);

//   useEffect(() => {
//     const fetchComputers = async () => {
//       try {
//         const response = await API.get("/computers"); // Fetch computers from API

//         const totalComputers = response.data.length;
//         const needsRepair = response.data.filter(
//           (computer) => computer.isFaulty
//         ).length;
//         const inRepair = response.data.filter(
//           (computer) => computer.repairDetails.status.type === "in_progress"
//         ).length;
//         const repaired = response.data.filter(
//           (computer) => computer.repairDetails.status.type === "completed"
//         ).length;
//         const operational = response.data.filter(
//           (computer) =>
//             !computer.isFaulty &&
//             computer.repairDetails.status.type !== "in_progress"
//         ).length;

//         setStats({
//           totalComputers,
//           needsRepair,
//           inRepair,
//           repaired,
//           operational,
//         });

//         // Calculate make statistics
//         const makes = [
//           ...new Set(response.data.map((computer) => computer.make)),
//         ];
//         const makeStatistics = makes.map((make) => {
//           const makeComputers = response.data.filter(
//             (computer) => computer.make === make
//           );
//           const total = makeComputers.length;
//           const repaired = makeComputers.filter(
//             (computer) => computer.repairDetails.status.type === "completed"
//           ).length;
//           const needsRepair = makeComputers.filter(
//             (computer) => computer.isFaulty
//           ).length;
//           const avgRepairTime = "N/A"; // This would require additional data or calculation
//           const commonIssue = "N/A"; // This would require additional data or calculation

//           return {
//             make,
//             total,
//             repaired,
//             needsRepair,
//             avgRepairTime,
//             commonIssue,
//           };
//         });

//         setMakeStats(makeStatistics);
//       } catch (error) {
//         console.error("Error fetching computers:", error);
//       }
//     };

//     fetchComputers();
//   }, []);

//   return (
//     <div className="p-6 h-full">
//       {/* Existing Status Summary Cards */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
//         <div className="bg-blue-500 text-white p-4 rounded shadow">
//           <FaServer className="inline mr-2" />
//           <h3 className="text-lg">Total Computers</h3>
//           <p className="text-3xl">{stats.totalComputers}</p>
//         </div>
//         <div className="bg-red-500 text-white p-4 rounded shadow">
//           <FaTools className="inline mr-2" />
//           <h3 className="text-lg">Needs Repair</h3>
//           <p className="text-3xl">{stats.needsRepair}</p>
//         </div>
//         <div className="bg-yellow-500 text-white p-4 rounded shadow">
//           <FaTools className="inline mr-2" />
//           <h3 className="text-lg">In Repair</h3>
//           <p className="text-3xl">{stats.inRepair}</p>
//         </div>
//         <div className="bg-green-500 text-white p-4 rounded shadow">
//           <FaCheckCircle className="inline mr-2" />
//           <h3 className="text-lg">Repaired</h3>
//           <p className="text-3xl">{stats.repaired}</p>
//         </div>
//         <div className="bg-teal-500 text-white p-4 rounded shadow">
//           <FaDesktop className="inline mr-2" />
//           <h3 className="text-lg">Operational</h3>
//           <p className="text-3xl">{stats.operational}</p>
//         </div>
//       </div>

//       {/* New Statistics Summary Section */}
//       <div className="bg-gray-50 p-6 rounded-lg shadow mb-8">
//         <h3 className="text-xl font-semibold mb-4">Computer Make Statistics</h3>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//           {makeStats.map((stat, index) => {
//             const repairRate = ((stat.repaired / stat.total) * 100).toFixed(1);
//             return (
//               <div
//                 key={index}
//                 className="bg-white p-4 rounded-lg shadow hover:shadow-lg transition-shadow"
//               >
//                 {/* Make Header */}
//                 <h4 className="text-lg font-bold text-gray-800 mb-2 flex items-center">
//                   {stat.make}
//                   <span className="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
//                     {stat.total} Units
//                   </span>
//                 </h4>

//                 {/* Circular Progress for Repair Rate */}
//                 <div className="relative w-20 h-20 mx-auto mb-4">
//                   <svg className="w-full h-full" viewBox="0 0 36 36">
//                     <path
//                       className="text-gray-200"
//                       d="M18 2.0845
//                         a 15.9155 15.9155 0 0 1 0 31.831
//                         a 15.9155 15.9155 0 0 1 0 -31.831"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="3"
//                     />
//                     <path
//                       className="text-green-500"
//                       d="M18 2.0845
//                         a 15.9155 15.9155 0 0 1 0 31.831
//                         a 15.9155 15.9155 0 0 1 0 -31.831"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="3"
//                       strokeDasharray={`${repairRate}, 100`}
//                     />
//                   </svg>
//                   <div className="absolute inset-0 flex items-center justify-center">
//                     <span className="text-sm font-semibold">{repairRate}%</span>
//                   </div>
//                 </div>

//                 {/* Stats */}
//                 <div className="text-sm text-gray-600 space-y-1">
//                   <p>
//                     <FaCheckCircle className="inline text-green-500 mr-1" />
//                     Repaired: {stat.repaired}
//                   </p>
//                   <p>
//                     <FaTools className="inline text-red-500 mr-1" />
//                     Needs Repair: {stat.needsRepair}
//                   </p>
//                   {/* <p>
//                     Avg. Repair Time:{" "}
//                     <span className="font-medium">{stat.avgRepairTime}</span>
//                   </p>
//                   <p>
//                     Common Issue:{" "}
//                     <span className="italic">{stat.commonIssue}</span>
//                   </p> */}
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default DashboardHome;

import React, { useState, useEffect } from "react";
import { FaServer, FaTools, FaCheckCircle, FaDesktop } from "react-icons/fa";
import API from "../Context/api"; // Assuming API is your Axios instance configured with the base URL

function DashboardHome() {
  const [stats, setStats] = useState({
    totalComputers: 0,
    needsRepair: 0,
    inRepair: 0,
    repaired: 0,
    operational: 0,
  });

  const [makeStats, setMakeStats] = useState([]);

  // useEffect(() => {
  //   const fetchComputers = async () => {
  //     try {
  //       const response = await API.get("/computers"); // Fetch computers from API

  //       const totalComputers = response.data.length;

  //       const needsRepair = response.data.filter(
  //         (computer) => computer.fields?.IsFaulty === true
  //       ).length;

  //       const inRepair = response.data.filter(
  //         (computer) => computer.repairDetails.Status === "In Repair"
  //       ).length;
  //       const repaired = response.data.filter(
  //         (computer) => computer.repairDetails.Status === "Completed"
  //       ).length;
  //       const operational = response.data.filter(
  //         (computer) =>
  //           !computer.isFaulty && computer.repairDetails.Status !== "In Repair"
  //       ).length;

  //       setStats({
  //         totalComputers,
  //         needsRepair,
  //         inRepair,
  //         repaired,
  //         operational,
  //       });

  //       // Calculate make statistics
  //       const makes = [
  //         ...new Set(response.data.map((computer) => computer.make)),
  //       ];
  //       const makeStatistics = makes.map((make) => {
  //         const makeComputers = response.data.filter(
  //           (computer) => computer.make === make
  //         );
  //         const total = makeComputers.length;
  //         const repaired = makeComputers.filter(
  //           (computer) => computer.repairDetails.status === "completed"
  //         ).length;
  //         const needsRepair = makeComputers.filter(
  //           (computer) => computer.isFaulty
  //         ).length;
  //         const avgRepairTime = "N/A"; // This would require additional data or calculation
  //         const commonIssue = "N/A"; // This would require additional data or calculation

  //         return {
  //           make,
  //           total,
  //           repaired,
  //           needsRepair,
  //           avgRepairTime,
  //           commonIssue,
  //         };
  //       });

  //       setMakeStats(makeStatistics);
  //     } catch (error) {
  //       console.error("Error fetching computers:", error);
  //     }
  //   };

  //   fetchComputers();
  // }, []);

  useEffect(() => {
    const fetchComputers = async () => {
      try {
        const response = await API.get("/computers"); // Fetch computers from API

        const data = response.data || [];

        const totalComputers = data.length;

        const needsRepair = data.filter(
          (computer) => computer.fields?.IsFaulty === true
        ).length;

        const inRepair = data.filter(
          (computer) =>
            computer.repairDetails &&
            computer.repairDetails.Status?.toLowerCase() === "in repair"
        ).length;

        const repaired = data.filter(
          (computer) =>
            computer.repairDetails &&
            computer.repairDetails.Status?.toLowerCase() === "completed"
        ).length;

        const operational = data.filter(
          (computer) =>
            computer.fields?.IsFaulty !== true &&
            computer.repairDetails?.Status?.toLowerCase() !== "in repair"
        ).length;

        setStats({
          totalComputers,
          needsRepair,
          inRepair,
          repaired,
          operational,
        });

        // Calculate make statistics
        const makes = [
          ...new Set(data.map((computer) => computer.fields?.Make)),
        ];

        const makeStatistics = makes.map((make) => {
          const makeComputers = data.filter(
            (computer) => computer.fields?.Make === make
          );

          const total = makeComputers.length;

          const repaired = makeComputers.filter(
            (computer) =>
              computer.repairDetails?.Status?.toLowerCase() === "completed"
          ).length;

          const needsRepair = makeComputers.filter(
            (computer) => computer.fields?.IsFaulty === true
          ).length;

          const avgRepairTime = "N/A"; // Needs time data
          const commonIssue = "N/A"; // Needs issue analysis

          return {
            make,
            total,
            repaired,
            needsRepair,
            avgRepairTime,
            commonIssue,
          };
        });

        setMakeStats(makeStatistics);
      } catch (error) {
        console.error("Error fetching computers:", error);
        console.log(error);
      }
    };

    fetchComputers();
  }, []);

  return (
    <div className="">
      {/* Existing Status Summary Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
        <div className="bg-blue-500 text-white p-4 rounded shadow">
          <FaServer className="inline mr-2" />
          <h3 className="text-lg">Total Computers</h3>
          <p className="text-3xl">{stats.totalComputers}</p>
        </div>
        <div className="bg-red-500 text-white p-4 rounded shadow">
          <FaTools className="inline mr-2" />
          <h3 className="text-lg">Needs Repair</h3>
          <p className="text-3xl">{stats.needsRepair}</p>
        </div>
        <div className="bg-yellow-500 text-white p-4 rounded shadow">
          <FaTools className="inline mr-2" />
          <h3 className="text-lg">In Repair</h3>
          <p className="text-3xl">{stats.inRepair}</p>
        </div>
        <div className="bg-green-500 text-white p-4 rounded shadow">
          <FaCheckCircle className="inline mr-2" />
          <h3 className="text-lg">Repaired</h3>
          <p className="text-3xl">{stats.repaired}</p>
        </div>
        <div className="bg-teal-500 text-white p-4 rounded shadow">
          <FaDesktop className="inline mr-2" />
          <h3 className="text-lg">Operational</h3>
          <p className="text-3xl">{stats.operational}</p>
        </div>
      </div>

      {/* New Statistics Summary Section */}
      <div className="bg-gray-50 p-6 rounded-lg shadow mb-8">
        <h3 className="text-xl font-semibold mb-4">Computer Make Statistics</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {makeStats.map((stat, index) => {
            const repairRate = ((stat.repaired / stat.total) * 100).toFixed(1);
            return (
              <div
                key={index}
                className="bg-white p-4 rounded-lg shadow hover:shadow-lg transition-shadow"
              >
                {/* Make Header */}
                <h4 className="text-lg font-bold text-gray-800 mb-2 flex items-center">
                  {stat.make}
                  <span className="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                    {stat.total} Units
                  </span>
                </h4>

                {/* Circular Progress for Repair Rate */}
                <div className="relative w-20 h-20 mx-auto mb-4">
                  <svg className="w-full h-full" viewBox="0 0 36 36">
                    <path
                      className="text-gray-200"
                      d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                    />
                    <path
                      className="text-green-500"
                      d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                      strokeDasharray={`${repairRate}, 100`}
                    />
                  </svg>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="text-sm font-semibold">{repairRate}%</span>
                  </div>
                </div>

                {/* Stats */}
                <div className="text-sm text-gray-600 space-y-1">
                  <p>
                    <FaCheckCircle className="inline text-green-500 mr-1" />
                    Repaired: {stat.repaired}
                  </p>
                  <p>
                    <FaTools className="inline text-red-500 mr-1" />
                    Needs Repair: {stat.needsRepair}
                  </p>
                  {/* <p>
                    Avg. Repair Time:{" "}
                    <span className="font-medium">{stat.avgRepairTime}</span>
                  </p>
                  <p>
                    Common Issue:{" "}
                    <span className="italic">{stat.commonIssue}</span>
                  </p> */}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default DashboardHome;

// import React from "react";
// import { FaTools, FaCheckCircle, FaDesktop } from "react-icons/fa";

// function DashboardHome() {
//   const stats = {
//     totalComputers: 50,
//     needsRepair: 8,
//     inRepair: 5,
//     repaired: 12,
//     operational: 25,
//   };

//   // Sample data for computer makes (replace with real data later)
//   const makeStats = [
//     {
//       make: "Dell",
//       total: 20,
//       repaired: 8,
//       needsRepair: 2,
//       avgRepairTime: "3 days",
//       commonIssue: "Power Supply",
//     },
//     {
//       make: "HP",
//       total: 15,
//       repaired: 3,
//       needsRepair: 4,
//       avgRepairTime: "5 days",
//       commonIssue: "Overheating",
//     },
//     {
//       make: "Lenovo",
//       total: 10,
//       repaired: 1,
//       needsRepair: 1,
//       avgRepairTime: "2 days",
//       commonIssue: "Screen Failure",
//     },
//     {
//       make: "Other",
//       total: 5,
//       repaired: 0,
//       needsRepair: 1,
//       avgRepairTime: "4 days",
//       commonIssue: "Unknown",
//     },
//   ];

//   return (
//     <div className="p-6 h-full">
//       {/* Existing Status Summary Cards */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
//         <div className="bg-blue-500 text-white p-4 rounded shadow">
//           <h3 className="text-lg">Total Computers</h3>
//           <p className="text-3xl">{stats.totalComputers}</p>
//         </div>
//         <div className="bg-red-500 text-white p-4 rounded shadow">
//           <FaTools className="inline mr-2" />
//           <h3 className="text-lg">Needs Repair</h3>
//           <p className="text-3xl">{stats.needsRepair}</p>
//         </div>
//         <div className="bg-yellow-500 text-white p-4 rounded shadow">
//           <FaTools className="inline mr-2" />
//           <h3 className="text-lg">In Repair</h3>
//           <p className="text-3xl">{stats.inRepair}</p>
//         </div>
//         <div className="bg-green-500 text-white p-4 rounded shadow">
//           <FaCheckCircle className="inline mr-2" />
//           <h3 className="text-lg">Repaired</h3>
//           <p className="text-3xl">{stats.repaired}</p>
//         </div>
//         <div className="bg-teal-500 text-white p-4 rounded shadow">
//           <FaDesktop className="inline mr-2" />
//           <h3 className="text-lg">Operational</h3>
//           <p className="text-3xl">{stats.operational}</p>
//         </div>
//       </div>

//       {/* New Statistics Summary Section */}
//       <div className="bg-gray-50 p-6 rounded-lg shadow mb-8">
//         <h3 className="text-xl font-semibold mb-4">Computer Make Statistics</h3>
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//           {makeStats.map((stat, index) => {
//             const repairRate = ((stat.repaired / stat.total) * 100).toFixed(1);
//             return (
//               <div
//                 key={index}
//                 className="bg-white p-4 rounded-lg shadow hover:shadow-lg transition-shadow"
//               >
//                 {/* Make Header */}
//                 <h4 className="text-lg font-bold text-gray-800 mb-2 flex items-center">
//                   {stat.make}
//                   <span className="ml-2 text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
//                     {stat.total} Units
//                   </span>
//                 </h4>

//                 {/* Circular Progress for Repair Rate */}
//                 <div className="relative w-20 h-20 mx-auto mb-4">
//                   <svg className="w-full h-full" viewBox="0 0 36 36">
//                     <path
//                       className="text-gray-200"
//                       d="M18 2.0845
//                         a 15.9155 15.9155 0 0 1 0 31.831
//                         a 15.9155 15.9155 0 0 1 0 -31.831"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="3"
//                     />
//                     <path
//                       className="text-green-500"
//                       d="M18 2.0845
//                         a 15.9155 15.9155 0 0 1 0 31.831
//                         a 15.9155 15.9155 0 0 1 0 -31.831"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="3"
//                       strokeDasharray={`${repairRate}, 100`}
//                     />
//                   </svg>
//                   <div className="absolute inset-0 flex items-center justify-center">
//                     <span className="text-sm font-semibold">{repairRate}%</span>
//                   </div>
//                 </div>

//                 {/* Stats */}
//                 <div className="text-sm text-gray-600 space-y-1">
//                   <p>
//                     <FaCheckCircle className="inline text-green-500 mr-1" />
//                     Repaired: {stat.repaired}
//                   </p>
//                   <p>
//                     <FaTools className="inline text-red-500 mr-1" />
//                     Needs Repair: {stat.needsRepair}
//                   </p>
//                   <p>
//                     Avg. Repair Time:{" "}
//                     <span className="font-medium">{stat.avgRepairTime}</span>
//                   </p>
//                   <p>
//                     Common Issue:{" "}
//                     <span className="italic">{stat.commonIssue}</span>
//                   </p>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default DashboardHome;
